module.exports = __webpack_public_path__ + "img/금융산업.6d70f424.png";